import React from 'react'
import { Link } from 'react-router-dom'
import {
    dateFormatter,
    dateFormatterShort,
    timeFormatter,
} from '../../../../../helpers/dateFormatter'

function FixtureTemplate({ index, fixture, type }) {
    function formatTeamName(teamName, limit = 14) {
        const newTitle = []

        if (teamName.length > limit) {
            teamName.split(' ').reduce((acc, cur) => {
                if (acc + cur.length <= limit) {
                    newTitle.push(cur)
                }
                return acc + cur.length
            }, 0)

            return `${newTitle.join(' ')}`
        }
        return teamName
    }

    function fixtureStatusFormatter(status) {
        let statusFormatted

        if (status === 'FT') {
            statusFormatted = <small>FT</small>
        } else if (status === 'NS') {
            statusFormatted = <small>{dateFormatted}</small>
        }

        return statusFormatted
    }

    function fixtureStatusFormatterHTML(status, elapsed) {
        if (status === 'FT') {
            return <small>{dateFormatted}</small>
        } else if (status === 'NS') {
            return <small>{timeFormatted}</small>
        } else if (status === 'PST') {
            return <small>Postp</small>
        } else if (
            fixture.elapsed &&
            fixture.elapsed > 0 &&
            fixture.elapsed <= 90 &&
            fixture.statusShort !== 'FT'
        ) {
            return (
                <span className="text-success">
                    {fixture.elapsed + "'"}{' '}
                    <i className="fas fa-circle-notch fa-spin"></i>
                </span>
            )
        } else {
            return status
        }
    }

    const date = new Date(fixture.event_date)

    const dateFormatted = dateFormatterShort(date)
    const timeFormatted = timeFormatter(date)

    return (
        <div
            key={index}
            className="card card-body py-2 mb-1 bg-white"
            style={{ fontSize: '0.8rem' }}
        >
            <div className="row">
                <div className="col-7">
                    <Link
                        to={
                            type === 'small'
                                ? `/live-fixtures/single/${fixture.fixture_id}`
                                : `/live-fixtures/${fixture.fixture_id}`
                        }
                    >
                        <img
                            src={fixture.homeTeam.logo}
                            className="img-fluid teamLogo"
                        />{' '}
                        {formatTeamName(fixture.homeTeam.team_name)}
                    </Link>{' '}
                    <br />
                    <Link
                        to={
                            type === 'small'
                                ? `/live-fixtures/single/${fixture.fixture_id}`
                                : `/live-fixtures/${fixture.fixture_id}`
                        }
                    >
                        <img
                            src={fixture.awayTeam.logo}
                            className="img-fluid teamLogo"
                        />{' '}
                        {formatTeamName(fixture.awayTeam.team_name)}
                    </Link>
                </div>

                <div className="col-3">
                    {fixture.statusShort === 'FT' ? (
                        <small>FT</small>
                    ) : fixture.statusShort === 'NS' ? (
                        <small>{dateFormatted}</small>
                    ) : (
                        ''
                    )}
                    <br />
                    {fixtureStatusFormatterHTML(
                        fixture.statusShort,
                        fixture.elapsed
                    )}
                </div>

                <div className={`col-2 text-right`}>
                    <Link
                        to={
                            type === 'small'
                                ? `/live-fixtures/single/${fixture.fixture_id}`
                                : `/live-fixtures/${fixture.fixture_id}`
                        }
                    >
                        {fixture.goalsHomeTeam
                            ? fixture.goalsHomeTeam
                            : fixture.statusShort === 'NS'
                            ? '-'
                            : fixture.statusShort === 'PST'
                            ? '-'
                            : '0'}
                    </Link>
                    <br />
                    <Link
                        to={
                            type === 'small'
                                ? `/live-fixtures/single/${fixture.fixture_id}`
                                : `/live-fixtures/${fixture.fixture_id}`
                        }
                    >
                        {fixture.goalsAwayTeam
                            ? fixture.goalsAwayTeam
                            : fixture.statusShort === 'NS' ||
                              fixture.statusShort === 'PST'
                            ? '-'
                            : '0'}
                    </Link>
                </div>
            </div>
        </div>
    )
}
export default FixtureTemplate
